module.exports = __webpack_public_path__ + "static/tracer-city-2efca4095c4e8a516b1115600a48f1e0.png";